import * as React from 'react';
import { t } from '@moovly/i18n';
import { ModalContainer } from '@moovly/ui';
import { FontItem, createFont } from '../store/settings.store';
import CreateFontContainer from '../container/CreateFontContainer';
import { DefaultModalProps } from '../../../types/modal';
import { useDispatch } from 'react-redux';
import useCurrentUser from '../../../hooks/useCurrentUser';

const ModalSyle = { content: { maxWidth: 850 } };

export const CreateFontModal: React.FC<DefaultModalProps> = ({ setOpen, closeModal }) => {
  const { isOrganizationAdmin, groupsWithAdminRight, parentOrganizationId } = useCurrentUser();
  const dispatch = useDispatch<any>();

  const handleCreate = React.useCallback(
    (name: string, fonts: FontItem[]) => {
      if (dispatch) {
        dispatch(
          createFont({
            externalType: isOrganizationAdmin ? 'organization' : 'group',
            externalId: isOrganizationAdmin ? parentOrganizationId! : groupsWithAdminRight[0].id,
            name,
            fonts,
          })
        );
        closeModal();
      }
    },
    [dispatch, isOrganizationAdmin, parentOrganizationId, groupsWithAdminRight, closeModal]
  );
  return (
    <ModalContainer
      setOpen={setOpen}
      title={t('fonts.create.button')}
      confirmButtonText={t('fonts.create.button')}
      style={ModalSyle}
    >
      <CreateFontContainer onCreate={handleCreate} onClose={closeModal} />
    </ModalContainer>
  );
};

export default CreateFontModal;
